export default __webpack_public_path__ + "static/media/ex_img_03.bb513d12.png";